import { render, staticRenderFns } from "./ConferenceProducts.vue?vue&type=template&id=9f39feec&"
import script from "./ConferenceProducts.vue?vue&type=script&lang=js&"
export * from "./ConferenceProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports